<app-drawing-controls></app-drawing-controls>
